const Z_INDEX = {
    navbar: 99999,
    navbar_dropdown: 100002
}

export default Z_INDEX;const Z_INDEX = {
    navbar: 99999,
    navbar_dropdown: 100002
}

export default Z_INDEX;